/**
 * Pattern Store — UI pattern configuration
 *
 * Controls header, sidebar, and breadcrumb display patterns.
 * Pure client-side state, no API calls.
 */

import { create } from 'zustand';

interface PatternState {
  headerPattern: 'default' | 'minimal' | 'hidden';
  sidebarPattern: 'full' | 'icons' | 'hidden';
  breadcrumbEnabled: boolean;
}

interface PatternActions {
  setHeaderPattern: (pattern: PatternState['headerPattern']) => void;
  setSidebarPattern: (pattern: PatternState['sidebarPattern']) => void;
  toggleBreadcrumb: () => void;
  resetPatterns: () => void;
}

type PatternStore = PatternState & PatternActions;

const initialState: PatternState = {
  headerPattern: 'default',
  sidebarPattern: 'full',
  breadcrumbEnabled: true,
};

export const usePatternStore = create<PatternStore>()((set) => ({
  ...initialState,

  setHeaderPattern: (headerPattern) => set({ headerPattern }),
  setSidebarPattern: (sidebarPattern) => set({ sidebarPattern }),
  toggleBreadcrumb: () =>
    set((state) => ({ breadcrumbEnabled: !state.breadcrumbEnabled })),
  resetPatterns: () => set({ ...initialState }),
}));
